import React from 'react';
import * as S from './Slider.styles';

type ISliderProps = {
  children: React.ReactNode;
  gap?: number;
  className?: string;
};

export const Slider = ({ children, gap = 16, className }: ISliderProps) => (
  <S.SliderStyled data-testid='slider' $gap={gap} className={className}>
    {children}
  </S.SliderStyled>
);
